import { ValidationBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, HierarchyUtils, ValidationResultFail, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
// Constants
const VALIDATION_NAME = "OrganizerLimitValidation";
const VALIDATION_ID = "ORGANIZER_LIMIT_VALIDATION";
const ORGANIZER_BOX_ASSEMBLY_ID = "organizer-box-assembly";
const ORGANIZER_CONNECTOR_ID = "organizer-connector";
const ORGANIZER_ASSEMBLY_ID = "organizer-assembely";
const STACKABLE_BOX_KEY = "to-stakable-box";
export class OrganizerLimitValidation extends ValidationBase {
    constructor() {
        super(...arguments);
        this.name = VALIDATION_NAME;
        this.id = VALIDATION_ID;
    }
    validationOK() {
        return null;
    }
    validationFail(message) {
        return new ValidationResultFail(message, "");
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(Snap) {
        var _a, _b;
        const { guestRoot: entity, guestConnector, host } = Snap;
        if (!entity.hasComponent(COMPONENT_IDS.ORGANIZERS_COMPONENT)) {
            return this.validationOK();
        }
        const stackLimit = (_b = (_a = entity.getComponent(ComponentIds.META_DATA_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.metaData) === null || _b === void 0 ? void 0 : _b.stack;
        const isAssemblyOrganizer = this.isAssemblyOrganizer(entity);
        const hostConnectionOrganizer = this.isHostConnectionOrganizer(entity);
        const attachedToOrganizer = guestConnector.key === STACKABLE_BOX_KEY;
        const stackHeight = isAssemblyOrganizer
            ? this.calculateParentStackHeight(host)
            : this.calculateHostStackHeight(host);
        return this.isStackLimitExceeded(stackLimit, stackHeight, attachedToOrganizer, hostConnectionOrganizer)
            ? this.validationFail(`Can’t stack more than ${stackLimit} organizers on top of each other`)
            : this.validationOK();
    }
    calculateHostStackHeight(entity) {
        return !entity || !entity.hasComponent(COMPONENT_IDS.ORGANIZERS_COMPONENT)
            ? 1
            : 1 + this.calculateHostStackHeight(HierarchyUtils.parent(entity));
    }
    calculateParentStackHeight(host) {
        var _a;
        const parent = (_a = host === null || host === void 0 ? void 0 : host.getComponent(ComponentIds.CHILD_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.parent;
        return !parent || !parent.hasComponent(COMPONENT_IDS.ORGANIZERS_COMPONENT)
            ? 1
            : 1 + this.calculateParentStackHeight(HierarchyUtils.parent(parent));
    }
    isAssemblyOrganizer(entity) {
        var _a;
        return (((_a = entity.getComponent(ComponentIds.TEMPLATE_DATA_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.templateId) === ORGANIZER_BOX_ASSEMBLY_ID);
    }
    isHostConnectionOrganizer(entity) {
        var _a, _b, _c;
        const templateId = (_c = (_b = (_a = entity
            .getComponent(ComponentIds.HOST_CONNECTIONS_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.connections[0].hostConnectorEntity) === null || _b === void 0 ? void 0 : _b.getComponent(ComponentIds.TEMPLATE_DATA_COMPONENT_ID)) === null || _c === void 0 ? void 0 : _c.templateId;
        return (templateId === ORGANIZER_CONNECTOR_ID ||
            templateId === ORGANIZER_ASSEMBLY_ID);
    }
    isStackLimitExceeded(stackLimit, stackHeight, attachedToOrganizer, hostConnectionOrganizer) {
        return (stackHeight > stackLimit ||
            (attachedToOrganizer && hostConnectionOrganizer));
    }
}
